module.exports = __webpack_public_path__ + "static/media/draw.1a6a2ad1.svg";